import { render, staticRenderFns } from "./QuackReports.vue?vue&type=template&id=37da75a0"
import script from "./QuackReports.vue?vue&type=script&lang=js"
export * from "./QuackReports.vue?vue&type=script&lang=js"
import style0 from "./QuackReports.vue?vue&type=style&index=0&id=37da75a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports